export const SET_SELECTED_STORE = 'SET_SELECTED_STORE';
export const REQUIRE_SELECTED_STORE = 'REQUIRE_SELECTED_STORE';
export const SET_NEAREST_STORE = 'SET_NEAREST_STORE';
export const REQUIRE_NEAREST_STORE = 'REQUIRE_NEAREST_STORE';
export const BROWSER_GEO_PENDING = 'BROWSER_GEO_PENDING';
export const BROWSER_GEO_FOUND = 'BROWSER_GEO_FOUND';
export const FETCHING_SELECTED_STORE = 'FETCHING_SELECTED_STORE';
export const UPDATE_SELECTED_STORE = 'UPDATE_SELECTED_STORE';
export const RESET_SELECTED_STORE = 'RESET_SELECTED_STORE';
export const ADD_CREATED_AT_TIME = 'ADD_CREATED_AT_TIME';
export const FORCE_MANUAL_STORE_SELECTION = 'FORCE_MANUAL_STORE_SELECTION';

export const mutations = {
    [SET_SELECTED_STORE] (state, storeLocation) {
        state.fetchingSelectedStore = false;
        state.selectedStorePending = false;
        state.forceManualStoreSelection = false;

        var expireDate = new Date();
        
        expireDate.setTime(expireDate.getTime() + (30 * 24 * 60 * 60 * 1000));
        document.cookie = "location_id=" + storeLocation.ControlNbr + ";expires=" + expireDate.toUTCString() + ";path=/";

        state.selectedStore = storeLocation;
        state.selectedStoreID = storeLocation.ControlNbr;
        state.newLocationID = '';
        state.createdAt = Date.now();
    },

    [UPDATE_SELECTED_STORE] (state, newLocationID) {
        state.newLocationID = newLocationID;
        state.selectedStoreID = newLocationID;

        state.createdAt = Date.now();

        state.selectedStorePending = true;
        state.fetchingSelectedStore = false;
        state.forceManualStoreSelection = false;
    },

    [FETCHING_SELECTED_STORE] (state) {
        state.fetchingSelectedStore = true;
        state.selectedStorePending = true;
    },

    [REQUIRE_SELECTED_STORE] (state) {
        state.selectedStoreRequired = true;
        state.selectedStorePending = true;
    },

    [SET_NEAREST_STORE] (state, storeLocation) {
        state.nearestStore = storeLocation;
    },

    [REQUIRE_NEAREST_STORE] (state) {
        state.nearestStoreRequired = true;
    },

    [BROWSER_GEO_PENDING] (state) {
        state.browserGeoPending = true;
    },

    [BROWSER_GEO_FOUND] (state) {
        state.browserGeoPending = false;
    },

    [RESET_SELECTED_STORE] (state) {
        state = {};

        state.selectedStore = null;
        state.selectedStoreID = null;
        state.selectedStoreRequired = false;
        state.selectedStorePending = false;
        state.fetchingSelectedStore = false;
		state.browserGeoPending = false;
        state.nearestStoreRequired = true;
        state.newLocationID = '';
        state.createdAt = null;
        state.nearestStore = null;
        state.unverifiedControlNumber = '',
        state.forceManualStoreSelection = false;
    },

    [ADD_CREATED_AT_TIME] (state) {
        state.createdAt = Date.now();
    },

    [FORCE_MANUAL_STORE_SELECTION] (state) {
        state.forceManualStoreSelection = true;
    }
};